import { Eyebrow, MaskHeading, Reveal, Gold } from "./Motion";
import { LEADERS } from "./data";

const LeaderCard = ({ l, i }) => (
  <Reveal delay={i * 0.1} className="h-full">
    <article data-testid={l.testId} className="group flex h-full flex-col rounded-[24px] border border-ns-emerald/10 bg-white p-6 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-ns-gold/60 hover:shadow-[0_30px_60px_-35px_rgba(11,60,42,0.4)]">
      <div className="flex items-center gap-4">
        <span className="grid h-16 w-16 shrink-0 place-items-center rounded-2xl bg-ns-emerald font-serif text-2xl font-semibold italic text-ns-gold transition-transform duration-500 group-hover:rotate-[-6deg]">
          {l.initials}
        </span>
        <div>
          <h3 data-testid={`${l.testId}-name`} className="font-serif text-[1.45rem] font-semibold leading-tight text-ns-emerald">{l.name}</h3>
          <p data-testid={`${l.testId}-role`} className="mt-0.5 text-sm font-medium text-ns-bronze">{l.role}</p>
        </div>
      </div>
      <dl className="mt-5 space-y-2 border-t border-ns-emerald/10 pt-4 text-sm">
        <div><dt className="text-[11px] font-bold uppercase tracking-[0.16em] text-ns-muted">Leadership role</dt><dd className="text-ns-ink">{l.lead}</dd></div>
        <div><dt className="text-[11px] font-bold uppercase tracking-[0.16em] text-ns-muted">Key focus</dt><dd className="text-ns-ink">{l.focus}</dd></div>
      </dl>
    </article>
  </Reveal>
);

export const Leadership = () => (
  <section id="leadership" data-testid="leadership-section" className="bg-ns-ivory py-24 md:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow testId="leadership-eyebrow">04 / The People</Eyebrow>
          <MaskHeading
            testId="leadership-heading"
            className="mt-6 font-serif text-[2.6rem] font-semibold leading-[1.02] text-ns-emerald sm:text-6xl lg:text-7xl"
            lines={["Driven by passion,", <Gold key="g">defined by trust.</Gold>]}
          />
        </div>
        <Reveal className="lg:col-span-4 lg:col-start-9">
          <p data-testid="leadership-supporting-copy" className="text-base leading-relaxed text-ns-muted">
            Our leadership team works with complete dedication to empower business partners and deliver uncompromised health to every Indian household.
          </p>
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {LEADERS.map((l, i) => <LeaderCard key={l.testId} l={l} i={i} />)}
      </div>
    </div>
  </section>
);
